import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useAddRecruitment = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.addRecruitment,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === 'string' && query.queryKey[0].includes('recruitments/search'),
      });
    },
  });
};
